/* eslint-disable */
/**
 * @Desc:   与native交互函数
 * @Date:   2019-07-03
 * @Author: Bob
 */
import Jockey from '@/vendor/jockey.js'
import config from '@/service/config.js'
import loginData from '../../test/loginData'
import { setLoginCookie, clearLoignCookie } from './cookie'
import utils from '@/utils/utils'
const env = config.env

/**
 * 获取当前用户登录信息(native登录)，并且设置到cookie
 * @return {Promise}
 */
export function getUserProfile () {
  return new Promise(resolve => {
    Jockey.send('getUserProfile', payload => {
      if ((env === 'LOCAL' || utils.isWebLogin) && !payload) {
        if ((process.env.NODE_ENV === 'local' || utils.isWebLogin) && localStorage.getItem('cntloginData')) {
          payload = JSON.parse(localStorage.getItem('cntloginData'));
          payload.uin = `${payload.uin}`
          payload.clientid = `${payload.mmaclientid}`
          payload.rndkey = `${payload.rndkey}`
        } else {
          payload = loginData
        }
      }
      if (payload) {
        setLoginCookie(payload.uin, payload.session, payload.clientid, payload.tradeSession)
        resolve(payload)
      } else {
        // console.log('no login')
        resolve('')
        // reject('no login')
      }
      appLog(1, `getUserProfile, data=${JSON.stringify(utils.dealLog(payload), null, 2)}`)
    })
  })
}

export function getDebugInfo () {
  return new Promise(resolve => {
    const data = {
      nativeEncrypt: true,
      nativeXsign: true
    }
    if (env === 'Live' || env === 'UAT') {
      resolve(data)
    }
    Jockey.send('getDebugInfo', payload => {
      if (payload) {
        data.nativeEncrypt = payload.forbidEncrypt === 0,
        data.nativeXsign = payload.forbidSignature === 0
      }
      appLog(1, `getDebugInfo, data=${JSON.stringify(data, null, 2)}`)
      resolve(data)
    })
  })
}

export function handleServerError (errorCode, data = null) {
  Jockey.send('handleServerError', {
    errorCode,
    data
  })
}

// 文档：http://git.mhs.local/wm-mobile/smmart-docs/blob/develop/smmart_native_weex_api.md
// 设置顶部按钮
export function setNaviMenu (menus) {
  Jockey.send('setNaviMenu', {
    menus
  })
  menus.forEach(item => {
    item.event && item.callBack && listenerEvent(item.event, item.callBack)
  })
}


// 设置导航栏标题
export function setNaviTitle (title) {
  Jockey.send('setNaviTitle', {
    title
  })
}

/**
 * 监听native事件
 * @param {string} eventName 时间名称
 * @param {function} callBack 回调函数(data, complete)
 * callBack 参数： data是响应数据, complete是完成回调；
 * 如果callBack是同步的，则不需要手动触发第二个参数，如果callBack是异步的,则需要在完成后手动触发complete()
 */
export function listenerEvent (eventName, callBack) {
  Jockey.off(eventName)
  if (typeof callBack !== 'function') {
    callBack = function () {}
  }
  Jockey.on(eventName, callBack)
}

// 关闭当前页面
export function closeSelf () {
  Jockey.send('closeSelf')
}

/**
 * 弹出分享面板
 */
export function showSharePanel (platform) {
  Jockey.send('showSharePanel', {
    platform
  })
}

/**
 * 分享面板中具体项目被点击时通知
 */
export function sharePanelClick (callBack) {
  listenerEvent('sharePanelClick', callBack)
}

/**
 * On back button pressed (Android v1.12.0 or above only)
 */
export function setBackBtnPressHandler (callBack) {
  Jockey.send('useCustomBackBtnHandler', {
    useCustomHandler: true
  })
  listenerEvent('backBtnPress', callBack)
}

export function unsetBackBtnPressHandler () {
  Jockey.send('useCustomBackBtnHandler', {
    useCustomHandler: false
  })
}

/**
 * 调用第三方分享
 */
export function share (obj) {
  const { title, desc, thumbnail, platform, type, url } = obj
  return new Promise(resolve => {
    Jockey.send(
      'share',
      {
        title,
        desc,
        thumbnail,
        platform,
        type,
        url
      },
      (payload) => {
        if (payload) {
          resolve(payload)
        }
      }
    )
  })
}

// 设置状态栏样式
export function setStatusBarStyle (mode) {
  Jockey.send('setStatusBarStyle', {
    mode
  })
}

// 获取状态栏样式
export function getStatusBarHeight () {
  return new Promise(resolve => {
    Jockey.send('getStatusBarHeight', {}, payload => {
      resolve(payload)
    })
  })
}

// 获取设备网络状态
export function getNetworkStatus () {
  return new Promise(resolve => {
    Jockey.send('getNetworkStatus', {}, (payload) => {
      if (payload) {
        return resolve(payload)
      }
      return resolve('')
    })
  })
}

/**
 * 打开指定文件
 * @param {String} name 文件名称
 * @param {String} url 文件的URL
 * @api public
 */
export function openFile (name, url, canShare=true, downloadEnable=false) {
  const pdfUrl = `cnp://openPDF?url=${encodeURIComponent(
    url
  )}&title=${encodeURIComponent(name)}&canShare=${canShare}&downloadEnable=${downloadEnable}`
  Jockey.send('openPrivateURL', {
    url: pdfUrl
  })
}

/**
 * webView布局模式
 * @param {Number} mode 布局模式，默认按0处理
 * 0：normal (有导航栏)；
 * 1：underStatusBar (无导航栏，webView占状态栏以下全部区域)；
 * 2：fullscreen (全屏)，
 * 3: fullscreenWithoutNav(全屏模式排除底部虚拟按键，ios按2处理
 * @api public
 */
export function setWebLayoutMode (mode) {
  Jockey.send('setWebLayoutMode', { mode })
}

/**
 * 展示文字内容
 * @param {String} msg 展示内容
 * @param {Number} type toast的UI样式，0:正常-蓝色， 1:用户错误反馈-灰色， 2:系统错误反馈-红色。	不传或者非法值，默认按0处理。
 * @api public
 */
export function showToast (msg, type) {
  Jockey.send('showToast', { msg, type })
}

/**
 * 通过app打开url (暂时仅支持web方式)
 * @param {String} url url生成的详细规则，请参考：私有URL协议文档在(http://10.9.19.245/wm-mobile/connect-docs/blob/develop/connect_router.md)
 * @param {Number} present 传1时，会模态显示（从底部弹出）url指定的页面，不传或传其他值，则使用默认方式打开
 * @param {Number} webType 0：在线web， 1： 预设web； 默认为0，2：原生页面
 * @param {Number} stackMode 0：默认(在原有页面基础新加上url指定的页面)，1：从根页面开始(操作完成后，UI栈中只有原根页面和url指定的页面)
 */
export function openPrivateURL (url, present = 0, webType = 0, stackMode = 0) {
  if (config.env === 'LOCAL' && webType !== 2) {
    return window.open(url, '_target')
  }

  if (utils.isWebLogin()) {
    return window.location.href = url
  }

  if (webType === 0) {
    // 在线web
    url = `cnp://web?url=${encodeURIComponent(url)}`
  } else if (webType === 1) {
    // 预设web
    url = `cnp://presetWeb?id=${encodeURIComponent(url)}`
  } else if (webType === 2) {
    // 原生页面
    url = `cnp://${url}`
  }
  appLog(1, `openPrivateURL, ${url}`)
  Jockey.send('openPrivateURL', {
    url,
    present,
    stackMode
  })
}

/**
 * 显示加载中动画
 * @param {Number} type 0: 无半透蒙层无白色圆角背景无文字小蓝圈，1：有半透蒙层有白色圆角背景无文字大蓝圈，2：有半透蒙层有白色圆角背景带文字大蓝圈，3：无半透蒙层无白色圆角背景带文字大蓝圈
 * @param {String} text loading上显示的文字内容, 只有type的值为2和3时，该字段才会生效
 * @param {Number} coverNav  0: 不覆盖导航栏，1：覆盖导航栏, 不传或传其他未定义值，默认取0
 */
export function showLoading (type = 0, text, coverNav = 0) {
  Jockey.send('showLoading', {
    type,
    text,
    coverNav
  })
}

/**
 * 隐藏加载中动画
 * @param {Number} coverNav  0: 不覆盖导航栏，1：覆盖导航栏； 调用showLoading和该方法时，该字段的值要保持一致，否则无法做到隐藏
 */
export function hideLoading (coverNav = 0) {
  Jockey.send('hideLoading', {
    coverNav
  })
}

/**
 * 记录日志至app内
 * @param {Number} level 日志等级，0：debug；1：info；2：warn；3：error；默认按0处理
 * @param {String} msg 具体日志信息
 */
export function appLog (level, msg) {
  const newMsg = `======H5 LOG====== ${msg}`
  Jockey.send('appLog', {
    level,
    msg: newMsg
  })
}

/**
 * 开启右滑返回功能（IOS独有）
 * @param {String} type 0：不开启；1：开启；
 */
export function setSwipeBack (type) {
  Jockey.send('setSwipeBack', {
    type
  })
}

/**
 * 信用卡支付页回调
 */
export function credicardPaymentCallback () {
  Jockey.send('credicardPaymentCallback')
}

/**
 * 获取业务密码状态
 * @returns {String} fail:同步失败 unset：未设置业务密码 locked:业务密码锁定 
 * unexpired:业务密码在有效期内，expired、业务密码已经过期
 */
export function getBusPwdStatus () {
  return new Promise(resolve => {
    Jockey.send('getBusPwdStatus', {}, payload => {
      return resolve(payload)
    })
  })
}

/**
 * 校验业务密码
 * @returns {String} fail:业务密码同步失败，unexpired:业务密码有效期内,success: 成功,cancel:取消，
 * locked:业务密码被锁定,forgetPwd:用户点击忘记业务密码，进入业务密码重置流程
 */
export function verifyBusPwd () {

  const bypass = utils.isWebLogin

  return new Promise((resolve, reject) => {
    Jockey.send('verifyBusPwd', {}, payload => {
      if (env === 'LOCAL' || bypass) {
        payload = {
          result: 'unexpired'
        }
      }
      // 业务密码更新时，需更新tradeSession
      if (payload.result === 'success') {
        getUserProfile().then(() => {
          return resolve(payload)
        })
        .catch(err => {
          return reject(err)
        })
      } else { // 其它返回
        return resolve(payload)
      }
    })
  })
}

/**
 * 支付组件
 * @param {Object} params 支付参数
 *  1 payMethodList	Array[String]	支持的支付方式数组	fps:"F", credit card: "C" ,offline = "O"
 *  2	defaultMethod	String	默认选择的支付方式	非必传
 *  3	currency	String	货币类型	"HKD" "MOP" "USD"
 *  4	amount	String	金额
 *  5	equalHKAmount	String	等值港币	
 *  6	category	Int	服务类型	1:简易复效;2:G03;3:缴付续期保费;4:缴付非定期保费;5:申请更改保费
 *  7	agentsvcid	String	顾问服务id（非必填）
 *  8	policyno	String	保单编号
 *  9	policyholder	String	保单持有人
 *  10	policyInsurant	String	受保人
 *  11	epaymentid	Int	有效的支付id	有支付id的情况，会调用刷新支付入口接口，刷新支付。（非必填）
 * 
 *  @returns {Object} 
 *  (1) {String} result 支付完成结果
 *  success: 支付流程成功，接收到支付成功的状态; 
 *  fail: 支付失败，中止支付流程，调用失败情况下会返回code，根据code处理对应错误;
 *  cancel: 关闭了支付流程，包括关闭了支付的弹窗、fps支付页、信用卡支付页。 但是支付状态还未确定；
 *  paramsError: 参数错误
 *  (2) {Int} code fail 调用失败失败情况下的错误码,
 *  1000: 其他情况，例如支付选择前请求失败，native会弹出toast 反馈。; 2000: 顾问服务申请过期的情况;
 */
export function startPayment (params) {
  return new Promise(resolve => {
    Jockey.send('startPayment', params , payload => {
      appLog(1, `startPayment, data=${JSON.stringify(utils.dealLog(payload), null, 2)}`)
      return resolve(payload)
    })
  })
}

/**
 *  处理业务密码失效
 */
export async function handleTradeSessionFailed () {
  try {
    let data = await verifyBusPwd()
    if (data === 'fail') {
      showToast(this.$t('netErrorToast'), 1)
    } else if (data === 'success') {
      // 重新设置tradeSession
      getUserProfile()
    }
  } catch (err) {
    showToast(this.$t('netErrorToast'), 1)
  }
}

/**
 * 跳转短信验证页面
 * @param {Number} verType 业务模块 1.即磅验证
 * @param {Number} receiveType 接收类型 1 : 手机, 2: 邮箱
 * @param {String} receiver 接收方，手机号码或邮箱地址。非必填，默认值为用户的手机号码
 * @return {Promise} 0: 通过, 1: 未通过
 */
export function openVerificationCodePage (verType = 1,receiveType = 1, receiver) {
  return new Promise((resolve, reject) => {
    let body = {
      verType,
      receiveType
    }
    if (receiver !== void 0) {
      body.receiver = receiver
    }
    Jockey.send('openVerificationCodePage', body, payload => {
      return resolve(payload)
    })
  })
}
/**
 * @function takePicture 选择图片，返回图片 base64 编码
 * @param {Object} options {fileSize: 图片允许的最大值,默认值为 500KB。如果原图小于默认值, 则返回原图}
 * @return {Object} 示例：{"type":"CAMERA","isCanceled":"0","img":"/9j/4AAQSkZJRgABAQAAAQABAAD..."}
 * isCanceled	用户是否取消操作    	0：没有取消；1：取消，此时参数 type 和参数 img 无意义
 * type       拍照或者选取已有照片	 CAMERA：拍照；FILE：选取已有照片
 * img        照片的 base64 编码
 */
export function takePicture (options = { fileSize: 500 }) {
  return new Promise((resolve, reject) => {
    try {
      Jockey.send('takePicture', options, payload => {
        resolve(payload)
      })
    } catch (err) {
      reject(err)
    }
  })
}
/**
 * @function takePictureOid 选择图片并上传至后台，返回oid
 * @param {Object} options
 * {
 *   categoryid: 分类id，见http://confluence.mhs.local:8090/display/PROJ/OSS
 *   fileSize: 图片允许的最大值,默认值为 500KB。如果原图小于默认值, 则返回原图
 * }
 * @return {Object} 示例：{"type":"CAMERA","isCanceled":"0","img":"/9j/4AAQSkZJRgABAQAAAQABAAD..."}
 * isCanceled	用户是否取消操作    	0：没有取消；1：取消，此时参数 type 和参数 img 无意义
 * type       拍照或者选取已有照片	 CAMERA：拍照；FILE：选取已有照片
 * result     上传图片返回的后台结果Oid
 */
 export function takePictureOid (options = { categoryid: 'policy', fileSize: 500 }) {
  return new Promise((resolve, reject) => {
    try {
      Jockey.send('takePictureOid', options, payload => {
        resolve(payload)
      })
    } catch (err) {
      reject(err)
    }
  })
}
/**
 * @function showPhotoBrowser 调用native组件展示图片
 * @param {Array} urls 照片的url 数组
 * @param {Number} index 初始展示的index，默认是0，必须小于url数组长度
 */
export function showPhotoBrowser (options) {
  let params = { urls: options.urls, index: options.index || 0 };
  return new Promise((resolve, reject) => {
    try {
      Jockey.send('showPhotoBrowser', params)
    } catch (err) {
      reject(err)
    }
  })
}
/**
 * @function showPopoverMenuOnNavibar 在导航栏按钮下展示气泡菜单
 * @param {String} position 气泡出现方位,只支持两个值left,right ，其他值会被丢弃
 * @param {Number} index 气泡出现在那个按钮序号, 默认为: 0
 * @param {Array} items 菜单列表
 * items数组内参数：
 * {
 *   "title":"旋转", // 菜单文本
 *   "color":"#333333", // 菜单文本颜色
 *   "iconId":"icon_navi_rotate", // 菜单图标id，icon_navi_delete 删除按钮;icon_navi_rotate 旋转按钮
 *   "event":"onRotateClick" // 点击按钮后，native回调给h5的事件
 * }
 */
export function showPopoverMenuOnNavibar (options) {
  let params = {
    position: options.position,
    index: options.index || 0,
    items: options.items
  };
  return new Promise((resolve, reject) => {
    try {
      Jockey.send('showPopoverMenuOnNavibar', params)
      options.items.forEach(item => {
        item.event && item.callBack && listenerEvent(item.event, item.callBack)
      })
    } catch (err) {
      reject(err)
    }
  })
}

/**
 *  @function openCountryCodePage 跳转国家地区码选择页面，选择后返回。
 *  @return {Promise} 0:成功 1：取消
 */

export function openCountryCodePage () {
  return new Promise ((resolve, reject) => {
    try {
      Jockey.send('openCountryCodePage', {}, payload => {
        resolve(payload)
      })
    } catch (err) {
      reject(err)
    }
  })
}

/**
 *  @function setNaviColor 设置导航栏颜色
 *  @param {String} color 导航栏的颜色，形如： #FFEFD5 (不能传#fff这种，要传#ffffff)
 *  @param {float}  alpha 透明度：0~1 之间，0为全透明, 不传或传非法值，则按1处理
 */
export function setNaviColor (color, alpha = 1) { 
  let params = {
    color,
    alpha
  };
  try {
    Jockey.send("setNaviColor",params);
  } catch (err) {
    appLog(3, `设置导航栏颜色错误${err}`)
  }
}

/**
 * @function showNaviBottomLine  显示或隐藏导航栏阴影线
 * @param {Int} show 0：不显示；1：显示；默认按0处理
 */

export function showNaviBottomLine (show = 0) {
  let params = { show } 
  try {
    Jockey.send("showNaviBottomLine", params);
  } catch (err) {
    appLog(3, `显示或隐藏导航栏阴影线错误${err}`)
  }
}

export function startEkycScan (pcaptureType, prefNo, pcallbackurl) {
  return new Promise((resolve, reject) => {
    let body = {
      captureType:pcaptureType,
      refNo:prefNo,
      callbackUrl:pcallbackurl
    }
    try {
      // console.log(body)
      Jockey.send('startEkycScan', body, payload => {
        resolve(payload)
      })
    } catch (err) {
      reject(err)
    }
  })
}